import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner-container"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "select-buttons-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text-container" }
const _hoisted_6 = { class: "main-text" }
const _hoisted_7 = { class: "subtext" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "action-button-container" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "select-buttons-container" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "card"
}
const _hoisted_17 = { class: "action-button-container" }
const _hoisted_18 = ["disabled"]

import '@/assets/css/card.css';
	import { onMounted, ref, watch, computed } from 'vue';
	import { useRoute, useRouter } from 'vue-router';
	import axios from 'axios';
	import functions from '@/use/functions';
	import Spinner from '@/components/shared/Spinner.vue';
	import PermissionsWrapper from '@/components/wrappers/PermissionsWrapper.vue';
	import { Permissions, PermissionLevels } from '@/models/permissions';
	import { Disbursement, Draw, ValidDisbursementStatusIds, FormField, DrawStatuses } from '@/models/loans';
	import PostDisbursementChangeForm from './PostDisbursementChangeForm.vue';
	import DisbursementForm from './DisbursementForm.vue';
	import { useDisbursementFormFields } from '@/composables/loan/useDisbursementForm';
	import { usePostDisbursementChangeFormFields } from '@/composables/loan/usePostDisbursementChangeForm';
	import { useDisbursementData } from '@/composables/loan/useDisbursementData';
	import { usePostDisbursementChangeData } from '@/composables/loan/usePostDisbursementChangeData';
	import { RootStore } from "@/types/root-store";
	import store from "@/store";
	import { FormChangesResponse, FormChange } from "@/models/form";
	import { DisbursementStatusIds } from "@/types/disbursements";

	
export default /*@__PURE__*/_defineComponent({
  __name: 'DrawDisbursements',
  props: {
    loanId: {},
    draw: {},
    onDisbursementChangedAsync: { type: Function }
  },
  setup(__props: any) {

	const props = __props;

	const route = useRoute();
	const router = useRouter();

	const disbursementFormRef = ref<InstanceType<typeof DisbursementForm> | null>(null);

	const isLoading = ref<boolean>(true);
	const isSubmitting = ref<boolean>(false);
	const disbursements = ref<Disbursement[]>([]);
	const selectedDisbursement = ref<Disbursement | null>(null);
	const previousDisbursement = ref<Disbursement | null>(null);
	const mode = ref<'view' | 'edit' | 'add'>('view');
	const postDisbursementChangeFormVisible = ref<boolean>(false);
	
	const { disbursementStatusOptions, disbursementStatusReasonOptions } = useDisbursementData();
	const { formFields, validationSchema, keysToSkip, keysToRename } = useDisbursementFormFields({
		selectedDisbursement,
		mode,
		disbursementStatusOptions,
		disbursementStatusReasonOptions,
		loanId: computed(() => props.loanId),
		drawId: computed(() => props.draw.id),
		disbursements: disbursements,
		draw: computed(() => props.draw),
	});

	const { disbursementCancellationReasonOptions } = usePostDisbursementChangeData();
	const { changeFormFields, changeValidationSchema } = usePostDisbursementChangeFormFields({
		selectedDisbursement,
		disbursementCancellationReasonOptions
	});

	const oidcUser = computed(() => (store.state as RootStore)?.oidcStore?.user);

	const hasDrawRequestedAmount = computed<boolean>(() => {
		const value = props?.draw?.requestedAmount; 
		return (value !== null && value !== undefined && value > 0);
	});

	const showAddNewDisbursementButton = computed<boolean>(() => {
		const validDrawStatuses = [ DrawStatuses.Certified, DrawStatuses.LenderHold ];
		return disbursements.value?.length < 4 && validDrawStatuses.includes(props.draw.drawStatusTypeId) && hasDrawRequestedAmount.value;
	});

	const changeMode = (newMode: 'view' | 'edit' | 'add') => {
		if (newMode === 'add') {
			
			const disbCount = disbursements.value.length;
			const sequence = `${ disbCount.toString().length < 2 ? '0' :''}${disbCount + 1}`;

			previousDisbursement.value = selectedDisbursement.value;
			selectedDisbursement.value = new Disbursement({
				sequenceNumber: sequence,
				disbursementStatusTypeId: DisbursementStatusIds.SCHEDULED_DISBURSEMENT,
				certifiedAmount: props.draw.certifiedAmount
			});		
		}
		else if (newMode ==='view' && mode.value === 'add') {
			if (previousDisbursement.value) {
				selectedDisbursement.value = previousDisbursement.value;
			} else {
				selectedDisbursement.value = null;
			}
		}
		else if (newMode === 'view') {
			if (previousDisbursement.value) {
				selectedDisbursement.value = previousDisbursement.value;
			}
		}

		mode.value = newMode;
	};

	const canEditDisbursement = computed(() => {
		return ValidDisbursementStatusIds.includes(selectedDisbursement.value?.disbursementStatusTypeId || 0);
	});

	const selectDisbursement = (disbursement: Disbursement) => {
		selectedDisbursement.value = disbursement;

		mode.value = 'view';

		router.replace({
			query: { ...route.query, disbursementId: disbursement.id },
			hash: route.hash
		});
	};

	const showPostDisbursementChangeModal = () => (postDisbursementChangeFormVisible.value = true);

	const closePostDisbursementChangeModal = () => (postDisbursementChangeFormVisible.value = false);

	function getFormChanges() {
		const prefix = `Draw Seq. ${props.draw.sequenceNumber} / Disbursement Seq. ${disbursementFormRef.value?.formData?.sequenceNumber}`
		
		const options = {
			keysToSkip: keysToSkip,
			keysToRename: keysToRename,
			commentPrefix: mode.value === 'edit' || mode.value === 'add' ? `${prefix} ${mode.value === 'add' ? 'Added' : 'Updated'} | ` : null,
			userDisplayName: `${oidcUser.value.given_name} ${oidcUser.value.family_name}`,
			mode: mode.value
		};

		const initialValues = disbursementFormRef.value?.initialValuesProp;
		const updatedValues =  disbursementFormRef.value?.formData;

		if (updatedValues && updatedValues.comment) {
			updatedValues.comment = updatedValues.comment.trim();
		}

		const formChanges = functions.summarizeFormChanges(updatedValues, initialValues, options);
		const modalHtml = functions.buildFormChangesTable(formChanges.changes, mode.value);

		return { modalHtml, formChanges };
	}

	function discardChanges() {
		changeMode('view');
	}

	async function handleCancelButtonClick() {
		const { modalHtml, formChanges } = getFormChanges();
		const validateFormResponse =  await disbursementFormRef.value?.validate();
		const btnTitle = validateFormResponse?.valid ? 'Save and Close' : 'Resume Editing';
		// Check if changes exist
		if (modalHtml) {
			functions.openModal({
				title: "Alert",
				description: "The changes you made have not been saved.",
				buttons: [
					{ title: "Cancel", onClick: () => 
						{
							// exits the Edit mode without saving any changes
							discardChanges();
							functions.closeModal();
						} 
					},
					{ title: btnTitle, onClick: async () => {
							if (validateFormResponse?.valid) {
								// Presents the confirm your changes modal 
								if (disbursementFormRef.value) {
									await confirmChanges(disbursementFormRef.value?.formData)
								}
							} else {
								functions.closeModal();
							}
						} 
					},
				],
			});
		} else {
			discardChanges();
		}
	}

	async function createPostDisbursementChangeAsync(formData: Record<string, any>) {
		const disbursement = selectedDisbursement.value;

		if (!disbursement) {
			return;
		}

		isSubmitting.value = true;

		try {
			await axios.post(`/api/loanservice/disbursements/${disbursement.id}/post-disbursement-change`, {
				disbursementId: disbursement.id,
				originalDisbursementDate: disbursement.transactionDate,
				originalDisbursementAmount: disbursement.disbursedAmount,
				...formData
			});

			closePostDisbursementChangeModal();

			await props.onDisbursementChangedAsync();
		} catch (error) {
			functions.openModal({
				title: 'Oops!',
				description: 'There was an issue creating a post-disbursement change. Please try again later.'
			});
		} finally {
			isSubmitting.value = false;
		}
	}

	async function confirmChanges(formData: Record<string, any>) {
		const { modalHtml, formChanges } = getFormChanges();

		if (modalHtml) {
			functions.openModal({
				title: "Confirm",
				description: "Please review your changes before submitting...",
				html: modalHtml,
				buttons: [
					{ title: "Cancel", onClick: () => functions.closeModal() },
					{ title: "Save Changes", onClick: async () => {
							functions.setModalLoading(true);
							await saveChangesAsync(formData, formChanges) 
						} 
					},
				],
			});
		}
	}
	
	async function saveChangesAsync(formData: Record<string, any>, formChanges: FormChangesResponse) {
		if (mode.value === 'add') {
			await createDisbursementAsync(formData, formChanges);

			if (disbursements.value.length > 0) {
				selectDisbursement(disbursements.value[disbursements.value.length - 1]); // select the newest disbursement
			}
		} else if (mode.value === 'edit') {			
			await updateDisbursementAsync(formData, formChanges);
		}
	}

	async function createDisbursementAsync(formData: Record<string, any>, formChanges: FormChangesResponse) {
		isSubmitting.value = true;

		try {
			const request = {
				createDisbursementRequest: {
					drawId: props.draw.id,
					...formData
				},
				certificationMethodTypeId: props.draw.certificationMethodId,
				// Under v2 `draw.id` holds a certification id, so send it explicitly rather than
				// leaving the backend to guess which id space `drawId` is in.
				certificationId: props.draw.certificationId,
			}

			await axios.post(`/api/loanservice/loan/${props.loanId}/draw/${props.draw.id}/disbursement`, request);

			if (formChanges.comment) {
				await createCommentAsync(formChanges.comment);
			}

			await props.onDisbursementChangedAsync();
		} catch (error) {
			functions.openModal({
				title: 'Oops!',
				description: 'There was an issue creating a disbursement. Please try again later.'
			});
		} finally {
			isSubmitting.value = false;
		}
	}

	async function updateDisbursementAsync(formData: Record<string, any>, formChanges: FormChangesResponse) {
		const disbursement = selectedDisbursement.value;

		if (!disbursement) {
			return;
		}

		isSubmitting.value = true;

		try {
			const request = {
				id: disbursement.id,
				disbursementTypeId: disbursement.disbursementTypeId,
				...formData
			};

			await axios.post(`/api/loanservice/disbursements/${disbursement.id}`, request);

			if (formChanges.comment) {
				await createCommentAsync(formChanges.comment);
			}

			await props.onDisbursementChangedAsync();
		} catch (error) {
			functions.openModal({
				title: 'Oops!',
				description: 'There was an issue updating the disbursement. Please try again later.'
			});
		} finally {
			isSubmitting.value = false;
		}
	}

	async function createCommentAsync(comment: string) {
		const request = {
			loanId: props.loanId,
			comment
		};

		await axios.post('/api/comments/loan', request);
	}

	async function getDisbursementsAsync() {
		try {
			isLoading.value = true;

			const response = await axios(`/api/loanservice/draws/${props.draw.id}/disbursements`);

			disbursements.value = response.data;

			selectInitialDisbursement();
		} catch (error) {
			functions.openModal({
				title: 'Oops!',
				description: 'There was an issue getting the disbursements. Please try again later.'
			});
		} finally {
			isLoading.value = false;
		}
	}

	const selectInitialDisbursement = () => {
		const queryDisbursementId = route.query.disbursementId;
		const firstDisbursement = disbursements.value[0];

		if (disbursements.value.length === 0) {
			router.replace({
				query: { ...route.query, disbursementId: undefined },
				hash: route.hash
			});

			return;
		}

		const matchingDisbursement = disbursements.value.find(
			(disbursement) => disbursement.id === Number(queryDisbursementId)
		);

		selectDisbursement(matchingDisbursement || firstDisbursement);
	};

	watch(
		() => props.draw,
		async () => {
			await getDisbursementsAsync(); // todo: fix on adding new draw...
		}
	);

	onMounted(async () => {
		await getDisbursementsAsync();
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(Spinner)
        ]))
      : _createCommentVNode("", true),
    (disbursements.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
          _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Disbursements", -1)),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(disbursements.value, (disbursement) => {
              return (_openBlock(), _createElementBlock("button", {
                key: disbursement.id,
                class: _normalizeClass(['icon-button', { secondary: disbursement != selectedDisbursement.value }]),
                onClick: ($event: any) => (selectDisbursement(disbursement))
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "icon icon-money" }, null, -1)),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(disbursement.disbursedAmountFormatted), 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(disbursement.transactionDateDisplay), 1)
                ])
              ], 10, _hoisted_4))
            }), 128)),
            (showAddNewDisbursementButton.value)
              ? (_openBlock(), _createBlock(PermissionsWrapper, {
                  key: 0,
                  permissionIds: [_unref(Permissions).Draws],
                  permissionLevel: _unref(PermissionLevels).Create
                }, {
                  default: _withCtx(() => [
                    (mode.value !== 'edit')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "icon-button dashed",
                          disabled: mode.value == 'add',
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeMode('add')))
                        }, [...(_cache[4] || (_cache[4] = [
                          _createElementVNode("span", { class: "icon" }, "+", -1),
                          _createElementVNode("div", { class: "text-container" }, [
                            _createElementVNode("span", { class: "main-text" }, "Add New")
                          ], -1)
                        ]))], 8, _hoisted_8))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["permissionIds", "permissionLevel"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(PermissionsWrapper, {
              permissionIds: [_unref(Permissions).Draws],
              permissionLevel: _unref(PermissionLevels).Update
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  (mode.value === 'view' && canEditDisbursement.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        disabled: isSubmitting.value,
                        class: "secondary",
                        onClick: showPostDisbursementChangeModal
                      }, " Post-Disbursement Change ", 8, _hoisted_11))
                    : _createCommentVNode("", true),
                  (canEditDisbursement.value && mode.value !== 'add')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        disabled: mode.value === 'edit',
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (changeMode('edit')))
                      }, " Edit ", 8, _hoisted_12))
                    : _createCommentVNode("", true),
                  (mode.value !== 'view')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        disabled: isSubmitting.value,
                        onClick: handleCancelButtonClick
                      }, " Cancel ", 8, _hoisted_13))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["permissionIds", "permissionLevel"]),
            (_openBlock(), _createBlock(DisbursementForm, {
              ref_key: "disbursementFormRef",
              ref: disbursementFormRef,
              key: selectedDisbursement.value?.id,
              mode: mode.value,
              fields: _unref(formFields),
              validationSchema: _unref(validationSchema),
              isSubmitting: isSubmitting.value,
              initialValues: selectedDisbursement.value,
              onSubmit: confirmChanges
            }, null, 8, ["mode", "fields", "validationSchema", "isSubmitting", "initialValues"]))
          ])
        ]))
      : (disbursements.value.length === 0 && showAddNewDisbursementButton.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _cache[8] || (_cache[8] = _createElementVNode("hr", null, null, -1)),
            _cache[9] || (_cache[9] = _createElementVNode("h3", null, "Disbursements", -1)),
            _createElementVNode("div", _hoisted_14, [
              (showAddNewDisbursementButton.value)
                ? (_openBlock(), _createBlock(PermissionsWrapper, {
                    key: 0,
                    permissionIds: [_unref(Permissions).Draws],
                    permissionLevel: _unref(PermissionLevels).Create
                  }, {
                    default: _withCtx(() => [
                      (mode.value !== 'edit')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "icon-button dashed",
                            disabled: mode.value == 'add',
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (changeMode('add')))
                          }, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("span", { class: "icon" }, "+", -1),
                            _createElementVNode("div", { class: "text-container" }, [
                              _createElementVNode("span", { class: "main-text" }, "Add New")
                            ], -1)
                          ]))], 8, _hoisted_15))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["permissionIds", "permissionLevel"]))
                : _createCommentVNode("", true)
            ]),
            (mode.value === 'add')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(PermissionsWrapper, {
                    permissionIds: [_unref(Permissions).Draws],
                    permissionLevel: _unref(PermissionLevels).Update
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("button", {
                          disabled: isSubmitting.value,
                          onClick: handleCancelButtonClick
                        }, " Cancel ", 8, _hoisted_18)
                      ])
                    ]),
                    _: 1
                  }, 8, ["permissionIds", "permissionLevel"]),
                  (_openBlock(), _createBlock(DisbursementForm, {
                    ref_key: "disbursementFormRef",
                    ref: disbursementFormRef,
                    key: selectedDisbursement.value?.id,
                    mode: mode.value,
                    fields: _unref(formFields),
                    validationSchema: _unref(validationSchema),
                    isSubmitting: isSubmitting.value,
                    initialValues: selectedDisbursement.value,
                    onSubmit: confirmChanges
                  }, null, 8, ["mode", "fields", "validationSchema", "isSubmitting", "initialValues"]))
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
    (postDisbursementChangeFormVisible.value)
      ? (_openBlock(), _createBlock(PostDisbursementChangeForm, {
          key: 3,
          isSubmitting: isSubmitting.value,
          fields: _unref(changeFormFields),
          validationSchema: _unref(changeValidationSchema),
          onSubmit: createPostDisbursementChangeAsync,
          onClose: closePostDisbursementChangeModal
        }, null, 8, ["isSubmitting", "fields", "validationSchema"]))
      : _createCommentVNode("", true)
  ]))
}
}

})